export function findVideoOffHole(context, startTimestamp) {
  return context.videoOffHoleList.find(
    (h) => startTimestamp > h.startUnix && startTimestamp < h.endUnix
  );
}

export function isValidVideoCurrentTime(timeInFragment) {
  return timeInFragment && parseInt(timeInFragment.videoCurrentTime) > 1;
}
